import { render } from "./BotaoSalvar.vue?vue&type=template&id=4c527b12&scoped=true"
import script from "./BotaoSalvar.vue?vue&type=script&lang=ts"
export * from "./BotaoSalvar.vue?vue&type=script&lang=ts"

import "./BotaoSalvar.vue?vue&type=style&index=0&id=4c527b12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c527b12"

export default script